import React from 'react';
import {Term, TermLight} from "./interfaces";
import {useAtom} from "jotai";
import {
  activeFiltersAtom,
  availableFilterAtom,
  currentFilterStepAtom,
  filterReverseAtom,
  finishedAtom, termsBundleAtom
} from "../../atoms/atoms";
import styled from "styled-components/macro";
import TermColorist from "./TermColorist";
import {useResetAtom} from "jotai/utils";
import ReactGA from 'react-ga4';

interface SingleTermProps {
  term: Term
}

interface StyleProps {
  currentColor: any
}

export type SingleTermComponent = (props: SingleTermProps) => JSX.Element;

export const ColoredTermBubble = styled.button<StyleProps>`
  font-family: "Helvetica Now Micro W01 Medium", sans-serif;
  letter-spacing: -0.02em;
  background-color: ${props => props.currentColor.background};
  border-radius: 1.111rem;
  border: 2px solid ${props => props.currentColor.background};
  padding: 6px 16px 7px;
  font-size: 13px;
  line-height: 19px;
  cursor: pointer;
  color: ${props => props.currentColor.text};

  &:hover {
    border-color: ${props => props.currentColor.background};
    color: ${props => props.currentColor.textHover};
    background-color: ${props => props.currentColor.backgroundHover};
  }
`;

const SingleTerm: SingleTermComponent = ({term}) => {
  const resetFilterReverse = useResetAtom(filterReverseAtom);
  const [,setFinished] = useAtom(finishedAtom);
  const [terms] = useAtom(termsBundleAtom);
  const [currentFilterStep, setCurrentFilterStep] = useAtom(currentFilterStepAtom);
  const [activeFilters, setActiveFilters] = useAtom(activeFiltersAtom)
  const [availableFilters] = useAtom(availableFilterAtom)

  const currentColor = TermColorist({currentFilterStep});

  const buttonClick = () => {
    const clickedTerm : TermLight = {
      'title': term.title,
      'id': term.id
    };
    const newFilterStep = currentFilterStep + 1;
    if (newFilterStep === terms.length) {
      localStorage.setItem('sopm_filter_result_view', 'true');
      setFinished(true);
    }
    resetFilterReverse();
    setCurrentFilterStep(newFilterStep);
    setActiveFilters([...activeFilters, clickedTerm]);
    ReactGA.event({
      category: 'ProductFinder',
      action: 'Set Filter',
      label: term.title
    });
  }

  const getKey = () => {
    return currentFilterStep + '_' + term.title;
  }

  if (availableFilters.length === 0) {
    return <ColoredTermBubble key={getKey()} currentColor={currentColor} onClick={buttonClick} type={'button'}>{term.title}</ColoredTermBubble>
  }

  if (availableFilters.includes(term.id)) {
    return <ColoredTermBubble key={getKey()} currentColor={currentColor} onClick={buttonClick} type={'button'}>{term.title}</ColoredTermBubble>
  }

  return <></>

}

export default SingleTerm;
